<template>
  <PopWidget :isShow="isShowPopWidget" :isFull="1" style="z-index:4;" 
    :width="containerWidth">
    <template v-slot:title>
      <img class="l-t-title" v-if="!isOut"
        src="../../assets/yuebao/pop-input-title.png" />
      <img class="l-t-title" v-else
        src="../../assets/yuebao/pop-output-title.png" />
    </template>
    <template v-slot:content>
      <div class="yeb-io-wrap" :class="{isout:isOut}">
        <div class="row-yeb flex">
          <img class="yeb-io-icode" src="../../assets/yuebao/yeb-io-icode.png" /> {{isOut?'余额宝':'账户'}}余额（元）
        </div>
        <div class="row-yeb flex amount" :class="{out:isOut}">
          <span v-if="isOut">
            ￥{{yebData.balance?yebData.balance:'0.00'}}
          </span>
          <span v-else>
            ￥{{amountCoin?amountCoin:'0.00'}}
          </span>
        </div>
        <div class="row-yeb flex">
          <div>转{{isOut?'出':'入'}}金额</div>
          <div class="yeb-wrapper">
            <input class="yeb-io-input" :placeholder="`请输入转${isOut?'出':'入'}金额`" 
              v-model="zhuanruAmount" />
            <img @click="allBtnClick" class="all-out-btn ease-btn-effe" src="../../assets/yuebao/all-out-btn.png" />
          </div>
        </div>
        <div class="row-yeb flex amount-des" v-if="!isOut">
          <div class="got-des">预计第一笔收益到账时间：</div>
          <div class="got-time">{{interestTime}}</div>
        </div>
        <div class="rule-descipt" v-if="!isOut">
          <img src="../../assets/yuebao/rule-ico1.png" alt="">转入金额必须≥1<br>
          <img src="../../assets/yuebao/rule-ico2.png" alt="">无转入次数限制;<br>
          <img src="../../assets/yuebao/rule-ico3.png" alt="">转入金额可累加，转入余额宝的金额按照活存获取流程，以万元每日利率进行计算。<br>
        </div>
        <div class="rule-descipt isout" v-if="isOut">
          <img src="../../assets/yuebao/rule-ico1.png" alt="">转出金额大于余额宝内金额，则无法转出。<br>
        </div>
        <img class="confirm-btn ease-btn-effe" src="../../assets/confirm-btn.png" 
          @click="confirmClick" />
      </div>
    </template>
  </PopWidget>
</template>

<script>
import { mapMutations } from 'vuex';
import PopWidget from '../common/PopWidget.vue'
import Request from '../../common/Request.js'
import Tool from '../../common/Tool.js'

export default{
  props:{
    show:Number,
    isOut:Number,
    yebData:Object,
  },
  data(){
    return {
      isShowPopWidget:0,
      zhuanruAmount:'',
      amountCoin:0,
      interestTime:'',
    }
  },
  methods:{
    ...mapMutations(['popMsg','showLoading','closeLoading']),
    getBalance(){
      let localUserInfo = Tool.getLocalUserinfo();
      if(localUserInfo){
        this.amountCoin = localUserInfo.coin;
        return;
      }
      Request.get(`/user/info`).then(res => {
        if(res.data && res.data.data){
          this.amountCoin = res.data.data.coin;
          Tool.setLocalUserinfo(res.data.data);
        }
      });
    },
    confirmClick(){
      if(!this.zhuanruAmount){
        this.popMsg(`请输入转${this.isOut?'出':'入'}金额`)
        return;
      }
      let amount = 1 * this.zhuanruAmount;
      if(isNaN(amount)){
        this.popMsg(`只能输入数字！`)
        return;
      }
      if(this.isOut){
        if(amount> this.yebData.balance){
          this.popMsg(`转出金额大于余额宝内金额！`)
          return;
        }
        this.$emit('outConfirm',amount);
      }else{
        let param = {
          amount:amount,
        }
        this.showLoading();
        Request.post('/yeb/transfer_in',param).then(res => {
          this.closeLoading();
          if(res.data.code == 0){
            this.popMsg('转入成功！')
            this.isShowPopWidget = 0;
            this.$emit('updateYuebao')
          }else if(res.data.msg){
            this.popMsg(res.data.msg)
          }
        }).catch(err => {
          this.closeLoading();
          if(err.response.data && err.response.data.msg){
            this.popMsg(err.response.data.msg)
          }
        });
      }
    },
    getInterestTime(){
      Request.post('/yeb/interest_time').then(res => {
        if(res.data.data && res.data.data.next){
          this.interestTime = res.data.data.next;
        }
      })
    },
    allBtnClick(){
      this.zhuanruAmount = 
        this.isOut ? this.yebData.balance:this.amountCoin;
    }
  },
  watch:{
    show(n){
      if(n){
        this.getBalance();
        if(!this.isOut){
          this.getInterestTime();
        }
      }
      this.isShowPopWidget = n;
      this.zhuanruAmount = '';
    }
  },
  computed:{
    containerWidth(){
      let w = this.isOut?'5.6rem':'6.6rem';
      return w;
    }
  },
  components:{
    PopWidget,
  }
}
</script>

<style scoped lang="stylus">
.l-t-title
  display block
  margin auto
.yeb-io-wrap
  width 100%
  height 2.5rem
  padding-top .06rem
  background-image url(../../assets/yuebao/guize-bg.png)
  background-size 100% 100%
  &.isout
    padding-top .22rem
  .confirm-btn
    width 1.2rem
    margin-top .04rem
  .yeb-io-icode
    width .2rem
    margin-right .08rem
  .row-yeb
    color #D5B18F
    font-size .18rem
    justify-content center
    align-items center
    &.amount
      margin .08rem 0
      color #dddcbd
      font-size .24rem
      &.out
        margin .16rem 0 .1rem 0
    .yeb-wrapper
      position relative
    .yeb-io-input
      width 2.68rem
      height .32rem
      padding-left .1rem
      margin-left .2rem
      border-radius .14rem
      background-color #31211B
    .all-out-btn
      position absolute
      right -.04rem
      top 0
      width .92rem
    .got-des
      color #9B776A
    .got-time
      color red
    &.amount-des
      font-size .14rem
      margin .08rem 0
  .rule-descipt
    padding-left .6rem
    text-align left
    color #9B776A
    img
      width .12rem
      margin-right .08rem
    &.isout
      padding-left 0
      width 100%
      text-align center
      margin .2rem 0
</style>